import * as React from 'react';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import ContentLoader from "react-content-loader"
import { ApplicationState } from '../../store/index';
import * as FlexiFormStore from '../../store/library/flexiform/FlexiForm';
import * as AccountStore from '../../store/siteaccount/Account';
import * as CategoryStore from '../../store/siteaccount/Category';
import * as PayMethodStore from '../../store/payment/PayMethod';
import * as SubscriptionStore from '../../store/patient/Subscription';
import * as  HeaderDrProfileStore from '../../store/widget/HeaderDrProfile';
import FlexiFormClass from '../../components/library/flexiform/FlexiForm'
import HeaderDrProfile from '../widget/HeaderDrProfile';
import { seo } from '../../helper/Script'
import { toastr } from 'react-redux-toastr';
import * as LanguageResourcesStore from '../../store/LanguageResoures';
import { scrollTop, setTittle } from '../../helper/formvalidation';
import Moment from 'moment';

type Props =
    SubscriptionStore.SubscriptionState & FlexiFormStore.FlexiListsState & AccountStore.AccountState & CategoryStore.CategoryState & PayMethodStore.PayMethodState & HeaderDrProfileStore.HeaderDrProfileState & LanguageResourcesStore.LanguageResouresState// ... state we've requested from the Redux store
    & typeof SubscriptionStore.actionCreators & typeof FlexiFormStore.actionCreators & typeof AccountStore.actionCreators & typeof CategoryStore.actionCreators & typeof PayMethodStore.actionCreators & typeof HeaderDrProfileStore.actionCreators & typeof LanguageResourcesStore.actionCreators// ... plus action creators we've requested
    & RouteComponentProps<{ startDateIndex: string }>; // ... plus incoming routing parameters
var paymethodid: any = "";
var languagecontent: any = "";
var pay_render: any = [];
var _currency: any = "";
var __currency: any = [];
var isAnnual: any = [];
var setIsAnnual: any = [];
var setSelectedPlan: any = [];
var PlanList: any = [];
var FrequencyList: any = [];
////const [isAnnual, setIsAnnual] = "";
//const [selectedPlan, setSelectedPlan] = useState(null);
class SubscriptionMethod extends React.PureComponent<Props> {

    constructor(props: any) {
        super(props);

    }
    public componentDidMount() {
        this.ensureDataFetched();
        scrollTop();
    }
    public componentDidUpdate() {
        seo(setTittle(languagecontent == "" ? "Subscription List" : languagecontent['breadcrumb']));
    }
    public render() {
        return (
            <React.Fragment>
                {this.renderSubscriptionMethod()}
            </React.Fragment>
        );
    }
    private ensureDataFetched() {
        this.props.getLangResources();
        this.props.getselectedsubscriptionList();
        this.props.getCategory();
        this.props.getPlanList();
        localStorage.removeItem("SubscriptionPlan");

    }

    redirectback = () => {
        this.props.redirectback();
    }
    selectPayType = (value: any) => {
        localStorage.setItem("SubscriptionPlan", JSON.stringify({ id: value.id, code: value.code, description: value.description, extRefId: value.extRefId, frequency: value.frequency, frequencyValue: value.frequencyValue, name: value.name, price: value.price, trialDays: value.trialDays, shortDescription: value.shortDescription }))
        _currency = this.props.Settings.filter((s: any) => s.name == "Currency");
        //var value: any;
        if (_currency.length == 0) {
            _currency = "";
        }
        else {
            if (_currency[0].value == "") {
                _currency = _currency[0].displayCode;
                localStorage.setItem("currency", _currency);
            }
            else {
                _currency = _currency[0].customizeValue;
                localStorage.setItem("currency", _currency);
            }


        }

        var currency: any = _currency;
        this.props.headerdrprofile.minPrice = "";
        this.props.headerdrprofile.minPrice = currency + value.price;
        localStorage.setItem("paidAmount", getDiscountPrice(value.price, 0))

    }
    submitMethod = () => {
        if (localStorage.getItem("SubscriptionPlan") == null && localStorage.getItem("PlanId") == "")
            return toastr.error('', "Please select a subscription plan to proceed");

        if (localStorage.getItem("PlanId"))
            this.props.getsubscriptionPlanList("2");
        else
            this.props.SubscriptionPlanSave("1");

    }





    toggleBilling = (plan: any) => {
        localStorage.setItem("Frequency", plan);
        this.props.getActivePlanList(plan);
        return (
            <React.Fragment>
                {this.renderSubscriptionMethod()}
            </React.Fragment>
        );
    };


    private renderSubscriptionMethod() {
        PlanList = this.props.planlists;
        FrequencyList = this.props.freqlists;
        _currency = this.props.Settings.filter((s: any) => s.name == "Currency");
        //var value: any;
        if (_currency.length == 0) {
            _currency = "";
        }
        else {
            if (_currency[0].value == "") {
                _currency = _currency[0].displayCode;
                localStorage.setItem("currency", _currency);
            }
            else {
                _currency = _currency[0].customizeValue;
                localStorage.setItem("currency", _currency);
            }


        }

        var currency: any = _currency;
        return (
            <div className="content">
                <div className="container">
                    <HeaderDrProfile />
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="max-w-md mx-auto p-6 border rounded shadow-md">
                                        <h2 className="text-2xl font-bold mb-6 text-center">Choose Your Subscription Plan</h2>
                                        <br />
                                        {/*<div style={styles.toggleContainer}>*/}
                                        {/*    <div style={styles.toggleBtn} >*/}
                                        {/*        <span onClick={() => this.toggleBilling("Daily")} className={localStorage.getItem('Frequency') == "Daily" ? 'active' : ''}>Daily</span>*/}
                                        {/*        <span onClick={() => this.toggleBilling("Month")} className={localStorage.getItem('Frequency') == "Month" ? 'active' : ''}>Month</span>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        {
                                            FrequencyList.length > 1 ?
                                                <div style={styles.toggleContainer}>
                                                    <div style={styles.toggleBtn}>

                                                        {
                                                            FrequencyList.map((freq: SubscriptionStore.PlanList) => (

                                                                <span
                                                                    onClick={() => this.toggleBilling(freq.frequency)}
                                                                    style={
                                                                        localStorage.getItem("Frequency") === freq.frequency
                                                                            ? { ...styles.active }
                                                                            : {}
                                                                    }
                                                                >
                                                                    <span style={{ verticalAlign: 'sub' }}>{freq.frequency}</span>
                                                                </span>


                                                            ))
                                                        }

                                                    </div>
                                                </div>
                                                : ""
                                        }


                                        <form className="text-center" style={{ display: "flex", flexWrap: "wrap" }}>

                                            {PlanList.map((planlist: SubscriptionStore.PlanList) => (



                                                <label
                                                    key={planlist.id}
                                                    className={`block border mb-4 cursor-pointer transition`}
                                                    style={{ width: "45%", marginLeft: "30px" }}
                                                >


                                                    {
                                                        localStorage.getItem("PlanId") ?
                                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                                                                <div style={{ background: 'rgb(218 234 163)' }}
                                                                    className={`border rounded-md p-4 cursor-pointer bg-green-50 border-green-500 border-gray-300`}
                                                                >
                                                                    <div className="flex items-center mb-2">
                                                                        <input
                                                                            type="radio"
                                                                            name="subscriptionPlan"
                                                                            value={planlist.id}
                                                                            onChange={() => (planlist.id)}
                                                                            checked={planlist.id == localStorage.getItem("PlanId") ? true : false}
                                                                            onClick={() => this.selectPayType(planlist)}
                                                                            className="mr-3"
                                                                            style={{ transform: 'scale(1.5)' }} /><br />
                                                                        <span className="font-semibold text-lg">{planlist.name}</span>
                                                                    </div>
                                                                    <br />
                                                                    {planlist.trialDays > 0 ?
                                                                        <b><span className="font-bold text-blue-700 ml-2">{currency + ' ' + getDiscountPrice(0, 0)}<br /><span className="font-bold text-blue-700 ml-2" style={{ textDecoration: 'line-through', color: 'gray' }}>{currency + getDiscountPrice(planlist.price, 0)}/{planlist.frequency}</span></span></b> :
                                                                        <b><span className="font-bold text-blue-700 ml-2">{currency + getDiscountPrice(planlist.price, 0)}/{planlist.frequency}</span></b>
                                                                    }
                                                                    <br />
                                                                    <br />
                                                                    {planlist.trialDays > 0 && (
                                                                        <span className={`color`} style={{ backgroundColor: 'rgb(102, 187, 106)', color: 'rgb(255, 255, 255)', width: '5vw', borderRadius: '20px', padding: '5px' }}>
                                                                            &nbsp;&nbsp;&nbsp; Try Free for &nbsp;
                                                                            {planlist.trialDays < 30
                                                                                ? `${planlist.trialDays} day${planlist.trialDays > 1 ? 's' : ''}`
                                                                                : planlist.trialDays < 365
                                                                                    ? `${Math.floor(planlist.trialDays / 30)} month${Math.floor(planlist.trialDays / 30) > 1 ? 's' : ''}`
                                                                                    : `${Math.floor(planlist.trialDays / 365)} year${Math.floor(planlist.trialDays / 365) > 1 ? 's' : ''}`
                                                                            }
                                                                            &nbsp;&nbsp;&nbsp;
                                                                        </span>
                                                                    )}
                                                                    <br />
                                                                </div>
                                                                <br />
                                                                <p dangerouslySetInnerHTML={{ __html: planlist.description }}></p>
                                                                <p dangerouslySetInnerHTML={{ __html: planlist.shortDescription.replace('{trialenddate}', getTrialEndDate(planlist.trialDays).toString()) }}></p>
                                                                <br />
                                                            </div>
                                                            :
                                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                                                                <div style={{ background: 'rgb(218 234 163)' }}
                                                                    className={`border rounded-md p-4 cursor-pointer bg-green-50 border-green-500 border-gray-300`}>
                                                                    <div className="flex items-center mb-2">
                                                                        <input
                                                                            type="radio"
                                                                            name="subscriptionPlan"
                                                                            value={planlist.id}
                                                                            onChange={() => (planlist.id)}
                                                                            onClick={() => this.selectPayType(planlist)}
                                                                            className="mr-2 radio-but"
                                                                            style={{ transform: 'scale(1.5)' }} /><br />
                                                                        <span className="font-semibold text-lg">{planlist.name}</span>

                                                                    </div>
                                                                    <br />
                                                                    <b><span className="font-bold text-blue-700 ml-2">{currency + getDiscountPrice(planlist.price, 0)}/{planlist.frequency}</span></b>

                                                                    <br />
                                                                    <br />
                                                                    {planlist.trialDays > 0 && (
                                                                        <span className={`color`} style={{ backgroundColor: 'rgb(102, 187, 106)', color: 'rgb(255, 255, 255)', width: '5vw', borderRadius: '20px', padding: '5px' }}>
                                                                            &nbsp;&nbsp;&nbsp; Try Free for &nbsp;
                                                                            {planlist.trialDays < 30
                                                                                ? `${planlist.trialDays} day${planlist.trialDays > 1 ? 's' : ''}`
                                                                                : planlist.trialDays < 365
                                                                                    ? `${Math.floor(planlist.trialDays / 30)} month${Math.floor(planlist.trialDays / 30) > 1 ? 's' : ''}`
                                                                                    : `${Math.floor(planlist.trialDays / 365)} year${Math.floor(planlist.trialDays / 365) > 1 ? 's' : ''}`
                                                                            }
                                                                            &nbsp;&nbsp;&nbsp;
                                                                        </span>
                                                                    )}
                                                                    <br />

                                                                </div>
                                                                <br />
                                                                <p dangerouslySetInnerHTML={{ __html: planlist.description }}></p>
                                                                <p dangerouslySetInnerHTML={{ __html: planlist.shortDescription.replace('{trialenddate}', getTrialEndDate(planlist.trialDays).toString()) }}></p>

                                                                <br />
                                                            </div>

                                                    }
                                                </label>
                                            ))}

                                            {/*<button*/}
                                            {/*    type="submit"*/}
                                            {/*    className="w-full py-2 bg-blue-600 text-white rounded font-semibold hover:bg-blue-700 transition"*/}
                                            {/*>*/}
                                            {/*    Confirm Selection*/}
                                            {/*</button>*/}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="submit-section text-right">
                        <button className="btn btn-secondary submit-btn" onClick={this.redirectback}>{languagecontent['backbutton'] == undefined ? "Back" : "Back"}</button>
                        <button className="btn btn-primary submit-btn" disabled={this.props.isPayLoading} type="button" onClick={() => this.submitMethod()}>{this.props.isPayLoading ? <i className="fa fa-spinner fa-spin"></i> : ""}Proceed</button>
                    </div>
                </div>
            </div >
        );
    }
}


export default connect(
    (state: ApplicationState) => ({ ...state.subscriptionDetail, ...state.flexiform, ...state.account, ...state.category, ...state.paymethod, ...state.headerDrProfile, ...state.langResources }), // Selects which state properties are merged into the component's props
    ({ ...SubscriptionStore.actionCreators, ...FlexiFormStore.actionCreators, ...AccountStore.actionCreators, ...CategoryStore.actionCreators, ...PayMethodStore.actionCreators, ...HeaderDrProfileStore.actionCreators, ...LanguageResourcesStore.actionCreators })// Selects which action creators are merged into the component's props
)(SubscriptionMethod as any);

export const getDiscountPrice = (currentprice: any, discountprice: any) => {
    var price: any = (currentprice - discountprice);
    return parseFloat(price).toFixed(2);
}

export function getTrialEndDate(trialDays: number): string {
    const appointmentTime = localStorage.getItem("AppointmentUTCTime");
    // Use current date if appointmentTime is null
    const baseDate = appointmentTime ? new Date(appointmentTime) : new Date();
    baseDate.setDate(baseDate.getDate() + trialDays);
    //return Moment(baseDate).format('DD MMM YYYY hh:mm a')
    return Moment.utc(baseDate).utcOffset(+parseInt(localStorage.getItem('timeOffset') || "")).format('DD MMM YYYY')

}

const styles = {
    subscriptionContainer: {
        maxWidth: "600px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
    },
    toggleContainer: {
        textAlign: "center" as const,
        marginBottom: "20px",
    },
    toggleBtn: {
        display: "inline-flex",
        gap: "20px",
        cursor: "pointer",
        padding: "10px 10px",
        border: "1px solid #ccc",
        borderRadius: "25px",
        backgroundColor: "#c8e6c9",
        justifycontent: "space- between",

    },
    active: {
        backgroundColor: "#66bb6a",
        color: "#fff",
        width: "5vw",
        borderRadius: "15px",
        paddingBottom: "5px"

    },
    plans: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "20px",
        marginBottom: "20px",
    },
    plan: {
        border: "1px solid #ddd",
        padding: "15px",
        borderRadius: "10px",
        cursor: "pointer",
    },
    selected: {
        border: "2px solid green",
        backgroundColor: "#f6fff6",
    },
    price: {
        marginTop: "10px",
        fontSize: "14px",
        fontWeight: "bold",
    },
    buttons: {
        display: "flex",
        justifyContent: "space-between",
    },
    btnBack: {
        padding: "10px 15px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        background: "#fff",
        cursor: "pointer",
    },
    btnProceed: {
        padding: "10px 15px",
        border: "none",
        borderRadius: "6px",
        background: "green",
        color: "#fff",
        cursor: "pointer",
    },
};